import {EnumCorridorColor} from "./enum-corridor-color";

export class Coefficient {
    readonly serviceCode: string;
    readonly c10: number;
    readonly c10c50: number;
    readonly c50: number;
    readonly c50c90: number;
    readonly c90: number;
    readonly monthlyAmount: number;

    constructor(serviceCode: string, c10: number, c10c50: number, c50: number, c50c90: number, c90: number, monthlyAmount: number) {
        this.serviceCode = serviceCode;
        this.c10 = c10;
        this.c10c50 = c10c50;
        this.c50 = c50;
        this.c50c90 = c50c90;
        this.c90 = c90;
        this.monthlyAmount = monthlyAmount;
    }
    getCoefFromColor(quoteServiceAppliedPriceColor: string) {
        if (quoteServiceAppliedPriceColor === EnumCorridorColor.GREEN) {
            return this.c90;
        } else if (quoteServiceAppliedPriceColor === EnumCorridorColor.LIGHTGREEN) {
            return this.c50c90;
        } else if (quoteServiceAppliedPriceColor === EnumCorridorColor.ORANGE) {
            return this.c50;
        } else if (quoteServiceAppliedPriceColor === EnumCorridorColor.RED) {
            return this.c10c50;
        } else if (quoteServiceAppliedPriceColor === EnumCorridorColor.BLACK || quoteServiceAppliedPriceColor === EnumCorridorColor.BELOW_BLACK) {
            return this.c10;
        } else if (quoteServiceAppliedPriceColor === EnumCorridorColor.GRAY) {
            return 0;
        }
        else {
            throw new Error(`ServiceColor not supported : ${quoteServiceAppliedPriceColor}.`);
        }
    }
}
